var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"supplements"}},[_c('Datatable',{staticClass:"datatable",attrs:{"entity":"tax_group","globalActions":[{text: 'tax_group.new', method: _vm.onCreate}],"rowActions":[{text: 'datatable.edit', method: _vm.onRowEdit}, {text: 'datatable.delete', method: _vm.onRowDelete}],"onRowClick":_vm.onRowEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }